import { CheckIcon } from '@heroicons/react/20/solid'
import sparkles from '../../assets/icons8-sparkle-24.png'
const tiers = [
  {
    name: 'Premium',
    id: 'tier-premium',
    href: '/signup',
    priceMonthly: '$19',
    priceMonthlyDiscounted: '$3',
    description: "Perfect for individuals who want to save time on their manual or automated outreach.",
    features: [
      'Generate in seconds',
      '150 credits per month',
      'Support directly from the founder',
      "Personalize with prospect's LinkedIn"
    ],
    featured: true,
  },
  {
    name: 'Diamond',
    id: 'tier-diamond',
    href: '/signup',
    priceMonthly: '$149',
    priceMonthlyDiscounted: '$49',
    description: "Perfect for cold email agency owners.",
    features: [
        'Everything in Premium',
        'Save prompts',
        'Generate email sequences',
        '3000 credits per month',
      ],
    featured: false,
  },
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function Pricing() {
  return (
    <div className="relative isolate bg-white px-6 pt-24 sm:py-32 lg:px-8">
      <div className="mx-auto max-w-2xl text-center lg:max-w-4xl">
        <h2 className="text-base font-semibold leading-7 text-custom-orange">Pricing</h2>
        <p className="mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
          Save time on outreach <br/>at affordable price
        </p>
      </div>
      {/* <p className="mx-auto mt-6 max-w-2xl text-center text-lg leading-8 text-gray-600">
        Qui iusto aut est earum eos quae. Eligendi est at nam aliquid ad quo reprehenderit in aliquid fugiat dolorum
        voluptatibus.
      </p> */}
      <div className="mx-auto mt-16 grid max-w-lg grid-cols-1 items-center gap-y-6 sm:mt-20 sm:gap-y-0 lg:max-w-4xl lg:grid-cols-2">
      {tiers.map((tier, tierIdx) => (
          <div
          key={tier.id}
          className={classNames(
            tier.featured ? 'relative bg-white shadow-2xl' : 'bg-white/60 sm:mx-8 lg:mx-0',
            tier.featured
              ? ''
              : tierIdx === 0
              ? 'rounded-t-3xl sm:rounded-b-none lg:rounded-bl-3xl lg:rounded-tr-none'
              : 'sm:rounded-t-none lg:rounded-bl-none lg:rounded-tr-3xl',
            'rounded-3xl p-8 ring-1 ring-gray-900/10 sm:p-10',
            tierIdx === 1 ? 'lg:scale-90 lg:-ml-5' : ''
          )}
        >
            <h3 id={tier.id} className="text-base font-semibold leading-7 text-custom-orange">
              {tier.name}
            </h3>
            <p className="mt-4 flex items-baseline gap-x-2">
              <span className="text-5xl font-bold tracking-tight text-gray-900 "><strike>{tier.priceMonthly}</strike> {tier.priceMonthlyDiscounted}</span>
              {/* <span className="text-5xl font-bold tracking-tight text-gray-900 ">{tier.priceMonthlyDiscounted}</span> */}
              <span className="text-base text-gray-500">/month</span>
            </p>
            <p className="mt-6 text-base leading-7 text-gray-600">{tier.description}</p>
            <ul role="list" className="mt-8 space-y-3 text-sm leading-6 text-gray-600 sm:mt-10">
              {tier.features.map((feature) => (
                <li key={feature} className="flex gap-x-3">
                  <CheckIcon className="h-6 w-5 flex-none text-custom-orange" aria-hidden="true" />
                  {feature}
                </li>
              ))}
            </ul>
            <a
              href={tier.href}
              aria-describedby={tier.id}
              className={classNames(
                tier.featured
                  ? 'bg-custom-orange text-white shadow'
                  : 'text-custom-orange ring-1 ring-custom-orange ring-inset',
                  'mt-8 block rounded-md py-2.5 px-3.5 text-center text-sm font-semibold focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-custom-orange sm:mt-10'
              )}
            >
              <img src={sparkles} alt="sparkles" className="w-4 inline-block transform -translate-y-0.5" />&nbsp;&nbsp;Sign up for CopyBuddy
            </a>
          </div>
        ))}
      </div>
    </div>
  )
}
